<template>
  <div class="SpedBlocoK container">
    <h3>SPED - Gerador do Bloco K</h3>
    <hr/>
    <b-form v-on:submit.prevent="gerarSped">
      <b-form-group>
        <label class="col-12">
          Arquivo SPED - Cabeçalho (.txt, .sped)
          <span class="text-danger">*</span>
          <b-file name="fileSped" accept=".txt, .sped" required/>
        </label>

        <label class="col-12">
          Arquivo Pessoas (.xlsx)
          <b-file
              name="filePessoas"
              v-model="filePessoas"
              v-on:change="parsePessoas"
              accept=".xlsx"
          />
        </label>
      </b-form-group>
      <b-form-group>
        <label class="col-12">
          Layout
          <span class="text-danger">*</span>
          <b-select v-model="layout">
            <template slot="first">
              <!-- this slot appears above the options from 'options' prop -->
              <option :value="null" disabled>-- Selecione um layout --</option>
            </template>
            <option value="sped">SPED</option>
            <option value="inventario">Inventario</option>
          </b-select>
        </label>
      </b-form-group>

      <div v-if="layout === 'sped'">
        <b-form-group>
          <label class="col-12">
            Arquivo 0200 (.txt)
            <span class="text-danger">*</span>
            <b-file name="file0200" accept=".txt" required/>
          </label>
        </b-form-group>
        <b-form-group>
          <label class="col-12">
            Arquivo K200 (.txt)
            <span class="text-danger">*</span>
            <b-file name="filek200" accept=".txt" required/>
          </label>
        </b-form-group>
      </div>

      <div v-if="layout === 'inventario'">
        <b-form-group>
          <label class="col-6">
            Competência
            <span class="text-danger">*</span>
            <b-input
                type="month"
                :value="(new Date()).getFullYear()+'-'+((new Date()).getMonth()+1).toString().padStart(2,'0')"
                name="competencia"
                required
            />
          </label>
          <label class="col-6">
            Tipo Item
            <span class="text-danger">*</span>
            <b-select v-model="tipoItem" required>
              <option value="00">00 - Mercadoria para Revenda</option>
              <option value="01">01 - Matéria-Prima</option>
              <option value="02">02 - Embalagem</option>
              <option value="03">03 - Produto em Processo</option>
              <option value="04">04 - Produto Acabado</option>
              <option value="05">05 - Subproduto</option>
              <option value="06">06 - Produto Intermediário</option>
              <option value="07">07 - Material de Uso e Consumo</option>
              <option value="08">08 - Ativo Imobilizado</option>
              <option value="09">09 - Serviços</option>
              <option value="10">10 - Outros insumos</option>
              <option value="99">99 - Outras</option>
            </b-select>
          </label>
        </b-form-group>
        <b-form-group>
          <label class="col-12">
            Arquivo Inventario (.xls, .xlsx, .csv) *
            <b-file
                name="fileInventario"
                v-model="fileInventario"
                v-on:change="parseHeader"
                accept=".xls, .xlsx, .csv"
                required
            />
          </label>
        </b-form-group>

        <b-form-group v-if="headers.length">
          <label class="col-12 col-sm-6 col-md-4">
            Codigo
            <span class="text-danger">*</span>
            <b-select :options="headers" v-model="configLayout.codigo" required/>
          </label>
          <label class="col-12 col-sm-6 col-md-4">
            Descrição
            <span class="text-danger">*</span>
            <b-select :options="headers" v-model="configLayout.descricao" required/>
          </label>
          <label class="col-12 col-sm-6 col-md-4">
            NCM
            <span class="text-danger">*</span>
            <b-select :options="headers" v-model="configLayout.ncm" required/>
          </label>
          <label class="col-12 col-sm-6 col-md-3">
            Unidade
            <span class="text-danger">*</span>
            <b-select :options="headers" v-model="configLayout.unidade" required/>
          </label>
          <label class="col-12 col-sm-6 col-md-3">
            Quantidade
            <span class="text-danger">*</span>
            <b-select :options="headers" v-model="configLayout.quantidade" required/>
          </label>
          <label class="col-12 col-sm-6 col-md-3">
            Indicador Estoque
            <b-select :options="headers" v-model="configLayout.indicadorEstoque"/>
          </label>
          <label class="col-12 col-sm-6 col-md-3">
            Codigo Participante
            <b-select :options="headers" v-model="configLayout.codigoPart"/>
          </label>
        </b-form-group>
      </div>

      <b-form-group class="col-12">
        <b-btn type="submit" variant="success">Gerar arquivo SPED - Bloco K</b-btn>
      </b-form-group>
    </b-form>
  </div>
</template>


<script>
import _get from 'lodash/get'

import XLSX from 'xlsx'
import Papa from 'papaparse'
import { download, readAsText } from '@/libs/utils'

const parseCsv = inputFile => {
  return new Promise((resolve, reject) => {
    Papa.parse(inputFile, {
      header: true,
      trimHeaders: true,
      encoding: 'ascii',
      skipEmptyLines: true,
      complete (results) {
        resolve(results.data)
      }
    })
  })
}

const parseXlsx = async inputFile => {
  const data = await readAsArrayBuffer(inputFile)
  const wb = XLSX.read(data, { type: 'array' })
  const s0 = wb.SheetNames[0]

  const json_data = XLSX.utils.sheet_to_json(wb.Sheets[s0], {
    raw: true
  })

  return json_data
}

const parseFile = async inputFile => {
  const ext = inputFile.name.split('.').pop()

  switch (ext.toLowerCase()) {
    case 'csv':
      return await parseCsv(inputFile)
    case 'xls':
    case 'xlsx':
      return await parseXlsx(inputFile)
  }
}

const readAsArrayBuffer = inputFile => {
  const tmpReader = new FileReader()

  return new Promise((resolve, reject) => {
    tmpReader.onerror = () => {
      tmpReader.abort()
      reject(new Error('Problem reading file'))
    }

    tmpReader.onload = () => {
      resolve(tmpReader.result)
    }

    tmpReader.readAsArrayBuffer(inputFile)
  })
}

const parseLayout = async (inputFile, params) => {
  const data = await parseFile(inputFile)
  const { config, tipoItem, competencia } = params

  console.log(config)
  return {
    r200: makeR200(data, config, tipoItem),
    k200: makeK200(data, config, competencia)
  }
}

const makeR200 = (data, config, tipoItem) => {
  const r200 = []
  data.forEach(reg => {
    r200.push(
        `|0200|${reg[config.codigo]}|${reg[config.descricao]}|||${
            reg[config.unidade]
        }|${tipoItem}|${reg[config.ncm]}||||||`
    )
  })
  return r200
}

const formatDateSPED = date => {
  const s = date
      .toISOString()
      .substring(0, 10)
      .split('-')
  return `${s[2]}${s[1]}${s[0]}`
}

const makeK200 = (data, config, competencia) => {
  const dataInicial = new Date(competencia + '-01')
  const dataFinal = new Date(
      dataInicial.getFullYear(),
      dataInicial.getMonth() + 2,
      0
  )

  const k200 = [
    '|K001|0|',
    `|K100|${formatDateSPED(dataInicial)}|${formatDateSPED(dataFinal)}|`
  ]
  data.forEach(reg => {
    const indicadorEstoque = reg[config.indicadorEstoque]
        ? reg[config.indicadorEstoque]
        : '0'
    const codigoPart = reg[config.codigoPart] ? reg[config.codigoPart] : ''
    const dateSped = formatDateSPED(dataFinal)
    k200.push(
        `|K200|${dateSped}|${reg[config.codigo]}|${_get(reg, config.quantidade, 0)
            .toString()
            .replace('.', ',')}|${indicadorEstoque}|${codigoPart}|`
    )
  })
  return k200
}

export default {
  data () {
    return {
      layout: null,
      tipoItem: '01',
      fileInventario: null,
      filePessoas: null,
      configLayout: {
        codigo: null,
        descricao: null,
        quantidade: null,
        ncm: null,
        unidade: null,
        indicadorEstoque: null,
        codigoPart: null
      },
      headers: [],
      participantes: {},
      r200: [],
      k200: [],
      sped: []
    }
  },
  methods: {
    parsePessoas: async function (event) {
      (await parseXlsx(event.target.files[0])).forEach(p => {
        this.participantes[p.codigo] = p
      })
    },
    parseHeader: async function (event) {
      this.headers = Object.keys((await parseFile(event.target.files[0]))[0])
    },
    gerarSped: async function (event) {
      this.sped = (await readAsText(event.target.fileSped.files[0]))
          .split(/\n|\r\n/)
          .filter(r => r.match(/^\|0000|^\|0005/))

      const r0 = this.sped[0].split('|')
      const r5 = this.sped[1].split('|')

      switch (this.layout) {
        case 'sped':
          this.r200 = (await readAsText(event.target.file0200.files[0]))
              .split(/\n|\r\n/)
              .filter(r => r.startsWith('|0200|'))
          this.k200 = (await readAsText(event.target.filek200.files[0]))
              .split(/\n|\r\n/)
              .filter(r => r.match(/^\|K001|^\|K100|^\|K200/))
          break
        case 'inventario':
          const parsedInventario = await parseLayout(
              event.target.fileInventario.files[0],
              {
                config: this.configLayout,
                competencia: event.target.competencia.value,
                tipoItem: this.tipoItem
              }
          )
          this.r200 = parsedInventario.r200
          this.k200 = parsedInventario.k200
          break
      }

      const sped = []

      const k100 = this.k200.filter(r => r.startsWith('|K100|'))[0].split('|')

      sped.push(
          `|0000|012|1|${k100[2]}|${k100[3]}|${r0[6]}|${r0[7]}|${r0[8]}|${
              r0[9]
          }|${r0[10]}|${r0[11]}|${r0[12]}|${r0[13]}|${r0[14]}|${r0[15]}|`
      )
      sped.push('|0001|0|')
      sped.push(
          `|0005|${r5[2]}|${r5[3]}|${r5[4]}|${r5[5]}|${r5[6]}|${r5[7]}|${r5[8]}|${
              r5[9]
          }|${r5[10]}|`
      )

      const r150 = new Set(
          this.k200
              .map(r => r.split('|')[6])
              .filter(r => !(r == null || r === '' || !r))
      )
      r150.forEach(p => {
        const part = this.participantes[p]
        const reg = [
          '',
          '0150',
          p,
          _get(part, 'nome', ''),
          _get(part, 'cod_pais', ''),
          _get(part, 'cnpj', '').replace(/\D/g, ''),
          _get(part, 'cpf', ''),
          _get(part, 'ie', ''),
          _get(part, 'cod_mun', ''),
          _get(part, 'suframa', ''),
          _get(part, 'end', ''),
          _get(part, 'num', ''),
          _get(part, 'compl', ''),
          _get(part, 'bairro', ''),
          ''
        ]
        sped.push(reg.join('|'))
      })

      const r190 = new Set()

      this.r200.forEach(r => {
        const un = r.split('|')[6]
        r190.add(un)
      })

      r190.forEach(un => {
        sped.push(`|0190|${un}|${un}|`)
      })

      this.r200.forEach(l => {
        sped.push(l)
      })

      this.k200.forEach(l => {
        sped.push(l)
      })
      sped.push(`|K990|${this.k200.length + 1}|`)

      sped.push('|9001|0|')
      sped.push('|9900|0000|1|')
      sped.push('|9900|0001|1|')
      sped.push('|9900|0005|1|')
      if (r150.size) {
        sped.push(`|9900|0150|${r150.size}|`)
      }
      sped.push(`|9900|0190|${r190.size}|`)
      sped.push(`|9900|0200|${this.r200.length}|`)
      sped.push('|9900|K002|1|')
      sped.push('|9900|K100|1|')
      sped.push(
          `|9900|K200|${this.k200.filter(r => r.startsWith('|K200|')).length}|`
      )
      sped.push('|9900|K990|1|')

      sped.push('|9900|9999|1|')
      sped.push('|9900|9001|1|')
      sped.push(`|9900|9900|${r150.size ? '14' : '13'}|`)
      sped.push('|9900|9990|1|')
      sped.push(`|9990|${r150.size ? '16' : '15'}|`)
      sped.push(`|9999|${sped.length + 1}|`)

      download(sped.join('\r\n'))
    }
  }
}
</script>

